/**
 * Shared event name and opener for the in-app chatbot.
 *
 * Follows the same pattern as bugreport.ts so the Navbar can open
 * the floating Chatbot without coupling them directly.
 */

export const CHATBOT_OPEN_EVENT ="chatbot:open";

export const openChatbot = (): void => {
 if (typeof window ==="undefined") return;
 window.dispatchEvent(new CustomEvent(CHATBOT_OPEN_EVENT));
};
